<template>
  <div class="app_container">
    <el-table
      :row-style="{ color: '#51627D', fontWeight: 400 }"
      :header-cell-style="{ background: '#DCE7FA', color: '#343C4A', fontWeight: 500 }"
      :data="classList"
      border
      style="width: 100%">
      <el-table-column
        align="center"
        prop="classChildName"
        label="小班名称">
      </el-table-column>
      <el-table-column
        fixed="right"
        label="操作"
        width="200">
        <template slot-scope="scope">
          <el-tooltip content="报到管理" placement="top">
            <i class="iconfont ic_checkinmanagement iconfont-adapt" @click="goReportManage(scope.row)"></i>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>
    <div class="RCPagination">
      <butn
        style="float: left"
        btntype="primary"
        iconName="el-icon-arrow-left"
        title="返回"
        @click="checkBack"
      ></butn>
    </div>
  </div>
</template>

<script>
import butn from "@/components/button/index";
import {
  getChildClassList,
} from "@/api/class";
// import DropDown from "@/components/dropDown/index";

export default {
  components: {
    butn
  },
  data() {
    return {
      getChildClassList,
      classList: [],
      classId: ""
    };
  },
  created() {
    this.classId = this.$route.query.id || "";
    this.fetchChildClassList();
  },
  methods: {
    checkBack() {
      this.$router.push("/offlineClass");
    },
    // 查询小班列表
    fetchChildClassList() {
      getChildClassList({ classId: this.classId }).then(({ code, data }) => {
        if (code === 0) {
          this.classList = data || [];
        }
      });
    },
    goReportManage(item) {
      this.$router.push({
        path: "/offlineClass/reportManage",
        query: {
          id: this.classId,
          classChildId: item.uuid
        }
      });
    }
  },
};
</script>

<style lang="scss" scoped>
.handle_wrapper {
  margin-bottom: 10px;
}
/deep/ .drag-box {
  margin-left: 16px;
}
</style>
